"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Delay = require("../utils/Delay");
const _excluded = ["delay", "skeleton"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const SpinAnimation = (0, _styledComponents.keyframes)`
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
`;
const StyledSpinner = _styledComponents.default.div(({
  color,
  size
}) => (0, _styledComponents.css)`
    animation: 1s ${SpinAnimation} linear infinite;
    
    display: inline-block;
    vertical-align: top;
    border-radius: 50%;
    border-style: solid;
    border-color: ${() => {
  switch (color) {
    case 'primary':
      return 'var(--vcs-color--primary)';
    case 'secondary':
      return 'var(--text-secondary-color)';
    default:
      return color;
  }
}};
    border-top-color: transparent;
    
    ${() => {
  switch (size) {
    case 'lg':
      return `
                    width: 40px;
                    height: 40px;
                    border-width: 5px;
                `;
    case 'sm':
      return `
                    width: 11px;
                    height: 11px;
                    border-width: 2px;
                `;
    default:
      return null;
  }
}};
`);
const Spinner = _ref => {
  let {
      delay,
      skeleton
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Delay.Delay, {
    skeleton: skeleton,
    delay: delay
  }, /*#__PURE__*/_react.default.createElement(StyledSpinner, rest));
};
exports.Spinner = Spinner;
Spinner.defaultProps = {
  size: 'lg',
  delay: 0,
  skeleton: null,
  color: 'primary'
};
Spinner.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.oneOf(['sm', 'lg']),
  delay: _propTypes.default.number,
  skeleton: _propTypes.default.node
};